import { ApiClient } from '@/apiClient'
import type { DocumentsList, Document } from '@/interfaces/documents'

export class DocumentsService {
  apiClient = new ApiClient()

  async getDocuments(folder:string): Promise<DocumentsList> {
    return this.apiClient
      .getDocuments(folder)
      .then((response: any) => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }
      })
  }
  async getDataUrl(id:string, name:string): Promise<string> {
    return this.apiClient
      .getDataUrl(id, name)
      .then((response: any) => {
        return response;
      })
  }
  async download(id:string, name:string) {
    await this.apiClient
      .download(id, name)
  }
}
export const DocumentService = new DocumentsService()